import {Injectable} from '@angular/core';
import {List} from "../pages/list/list";
import {CustomDetail} from "../pages/custom/customdetail/customdetail";
import {IFrame} from "../pages/iframe/iframe";
import {ChartPage} from "../pages/chartpage/chartpage";
import {Detail} from "../pages/detail/detail";
import {Table} from "../pages/table/table";
import {GridBoxPage} from "../pages/grid-box/grid-box";
import {HomePage} from "../pages/home/home";
import {PdfViewerPage} from "../pages/pdf-viewer/pdf-viewer";
import {ScannerPage} from "../pages/scanner/scanner";
import {ScannerSortPage} from "../pages/scanner-sort/scanner-sort";
import {Signature} from "../pages/signature/signature";
import {LoginPage} from "../pages/login/login";
import {MessagePage} from "../pages/message/message";
import {EbsWebService} from "./ebsWebService";
import {EbsWebServiceGlobals} from "./ebsWebServiceGlobals";
import { TreeviewPage } from '../pages/treeview/treeview';

@Injectable()
export class EbsComponentService {
  constructor(public  _ebsWebService: EbsWebService,
              public _ebsWebServiceGlobals: EbsWebServiceGlobals) {}

  getComponentByAction(action) {
    switch (action) {
      case "Table":
        return Table;
      case "List":
        return List;
      case "Detail":
        return Detail;
      case "Chart":
        return ChartPage;
      case "IFrame":
        return IFrame;
      case "ChartTypePie":
        return CustomDetail;
      case "GridBox":
        return GridBoxPage;
      case "File_PDF":
        return PdfViewerPage;
      case "Scanner":
        if(typeof this._ebsWebServiceGlobals.getProjectIdentifier() != "undefined" && this._ebsWebServiceGlobals.getProjectIdentifier() == "oio") {
          return ScannerSortPage;
        } else {
          return ScannerPage;
        }
      case "Signature":
        return Signature;
      case "LoginPage":
        return LoginPage;
      case "Message":
        return MessagePage;
      case "Link":
        return "Link";
      case "TreeView":
        return TreeviewPage;
      default:
        return HomePage;
    }
  }

  navigationController(element,navparams,navCtrl,component=null) {
    if (component == null){
      component = this.getComponentByAction(element.ViewTypeAction);
    }
    switch (element.ActionType) {
      case "Pop":
        let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(element.PostParameters);
        this._ebsWebService.postData(element.Action, postPayloadObject).toPromise().then(res=>{
          navCtrl.pop();
        }).catch(error => {
          console.error(error);
        });
        break;
      case "SetRoot":
        navCtrl.setRoot(component, navparams);
        break;
      default:
        navCtrl.push(component, navparams);
        break;
    }
  }

  urlNavigationController(params, navCtrl) {
    let view = "GridBox";
    if (params.district != "" && params.id != "") {
      view = "Detail";
    }

    let component = this.getComponentByAction(view);

    let getUserKey = this._ebsWebServiceGlobals.getUserHash();
    let userKey = "";
    if (getUserKey != null && getUserKey != "null" && typeof getUserKey != "undefined") {
      userKey = getUserKey;
    }
    
    let postparams = "userKey=" + userKey;
    postparams += "&action=" + params.action;
    postparams += "&path=&district=" + params.district;
    postparams += "&id=" + params.id;
    postparams += "&param1=&param2=&param3=&param4=&param5=&searchWord=" + params.searchword;

    let navParams = {
      title: "Stoffe",
      actionURL: this._ebsWebServiceGlobals.getEbsWebServiceEntryURL(),
      postParams: postparams
    }
    navCtrl.push(component, navParams);
  }
}


// WEBPACK FOOTER //
// ./src/services/ebsComponentService.ts